export const NOT_AVAILABLE = 'N/A';

// CaptionType values as transformed by the saga (parseEnumType converts numeric
// enum indices to their string keys from transactionCaptionTypes).
export const FIELD_CAPTION_TYPE = {
  ORDER_TOTAL: 'OrderTotal',
  PRICE_PER_UNIT: 'PricePerUnit',
  REFERENCE_NUMBER: 'ReferenceNumber',
  SUBMITTER: 'Submitter',
  SUMMARY: 'Summary',
  CREDIT_CARD: 'CreditCardLastFourDigits',
  SHIPPING_FEE: 'ShippingFee',
  INSURANCE_FEE: 'ShippingInsuranceFee',
  PRE_AUTH_AMOUNT: 'CreditCardAuthorizedAmount',
};

export const getTransactionField = (fields, captionType) =>
  (fields ?? []).find((f) => f.CaptionType === captionType) ?? null;

// Normalizes the GET orders/sfh/history response into the shape the timeline
// renders. The BE returns a flat array (PascalCase), one entry per step:
//
// [
//   { Key: 'requestSubmitted', IsCompleted: true,  DateTime: '2026-06-23T05:36:59.17', Cancellable: true  },
//   { Key: 'inTransit',        IsCompleted: false, DateTime: null,                     Cancellable: false },
//   ...
// ]
//
// dateTime:    BE timestamp string when the step completed, null while pending
// cancellable: true only while the order can still be cancelled
//
// Returns [] when there's no data yet — the screen shows a loader while the
// feed is in flight, so nothing static is ever rendered as real history.
export function buildTimelineSteps(history) {
  if (!Array.isArray(history)) return [];
  return history.map((step) => ({
    key: step.Key,
    status: step.IsCompleted ? 'completed' : 'pending',
    dateTime: step.DateTime,
    cancellable: Boolean(step.Cancellable),
  }));
}
